import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'hbh-ui-modules/dist/bundle.css';
import 'react-datepicker/dist/react-datepicker.css';
import './assets/styles/index.scss';

import { authConfig, axios } from '@common/utils';
import { AuthProvider } from 'hbh-ui-modules';
import { initSentry, ErrorBoundary as SentryErrorBoundary } from '@unbooking/sentry';

initSentry({
  dsn: process.env.REACT_APP_SENTRY_DSN ?? '',
  environment: process.env.REACT_APP_ENV ?? 'development',
  serviceName: 'hbh-emergency-travel-ui',
});

// Cast to avoid React type conflict with @unbooking/sentry peer deps
const ErrorBoundary = SentryErrorBoundary as unknown as React.ComponentType<{ children?: React.ReactNode }>;

ReactDOM.render(
  <ErrorBoundary>
    <React.StrictMode>
      <AuthProvider authConfig={authConfig} axiosInstance={axios}>
        <Router>
          <App />
        </Router>
      </AuthProvider>
    </React.StrictMode>
  </ErrorBoundary>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
